import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer, real } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

export const graphemeSubtlexTable = staticTable(
  "grapheme_subtlex",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    /** 1-based frequency rank (1 = most frequent). Derived from SUBTLEX-CH CHRCount. */
    rank: integer("rank").notNull(),

    /** CHR/million */
    frequencyPerMillion: real("frequency_per_million").notNull(),

    /** CHR-CD% */
    contextCoverage: real("context_coverage").notNull(),

    /** logCHR-CD */
    diversityScore: real("diversity_score").notNull(),
  },
  (table) => [index("grapheme_subtlex_grapheme_id_idx").on(table.graphemeId)],
);

export type GraphemeSubtlex = typeof graphemeSubtlexTable.$inferSelect;
